/** Injects Search Console verification meta tag from REACT_APP_GOOGLE_SITE_VERIFICATION. */
export function applyGoogleSiteVerification(): void {
  const token = process.env.REACT_APP_GOOGLE_SITE_VERIFICATION?.trim();
  if (!token) return;

  let el = document.querySelector('meta[name="google-site-verification"]');
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute('name', 'google-site-verification');
    document.head.appendChild(el);
  }
  el.setAttribute('content', token);
}
